module.exports = __webpack_public_path__ + "assets/most.f9dd85cb292baebc4ce43eb00186ae25.png";